import { Form } from '@unform/web';
import styled from 'styled-components';

import { ButtonConfirm } from '../../components/ButtonConfirm';
import { InputTextArea as InputTextAreaComponent } from '../../components/InputTextArea';
import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 460px;

  display: flex;
  flex-direction: column;

  background-color: ${colors.surfaceContainerLow};

  @media (max-width: 1199px) {
    min-width: auto;
  }
`;

export const Content = styled.div`
  padding: 28px;
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InputTextArea = styled(InputTextAreaComponent)`
  height: auto;
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  margin-top: 24px;
`;

export const Cancel = styled.button`
  padding: 0 20px;
  height: 44px;

  background-color: transparent;
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 12px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const Submit = styled(ButtonConfirm)`
  width: auto;
  height: 44px;
  padding: 0 24px;
  border-radius: ${radius.DEFAULT};
`;

export const SecondaryChannels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid ${colors.outlineVariant}30;
`;

interface SecondaryRowProps {
  disabled?: boolean;
}

export const SecondaryRow = styled.a<SecondaryRowProps>`
  display: flex;
  align-items: center;
  gap: 10px;

  text-decoration: none;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};

  span {
    font-size: 12.5px;
    color: ${colors.onSurfaceVariant};
  }

  ${props =>
    !props.disabled &&
    `
    &:hover span {
      color: ${colors.onSurface};
    }
  `}
`;

export const Badge = styled.span`
  margin-left: auto;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: ${colors.onSurfaceVariant}b3;
`;

export const CreditsNote = styled.p`
  margin-top: 20px;
  text-align: center;
  font-size: 10.5px;
  color: ${colors.onSurfaceVariant}b3;

  a {
    color: inherit;
  }
`;
